
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: 'WalletPage',
}) 
export default class WalletPage extends Vue {
}
